export default __webpack_public_path__ + "static/provider-dreamjobs-7e1cd26d4884e3fc570428cdb0c30dc0.jpg";